import React, {FC} from 'react';
import {useLocation} from 'react-router-dom';
import {LiveShoppingEvent} from '../../../../../grpc_client/grips/protos/shared/live_shopping_event';
import {ShareButton} from '../../../../../ui/ShareButton/ShareButton';
import {useComputeEventDetails} from '../../hooks/useComputeEventDetails';

export const LiveEventShareButton: FC<{event: LiveShoppingEvent}> = ({
  event,
}) => {
  const {pathname, search} = useLocation();
  const {isScheduledAfterToday} = useComputeEventDetails(event);

  const shareUrl = `${pathname}${search}${
    isScheduledAfterToday
      ? ''
      : (search.length === 0 ? '?' : '&') + 'autoplayLiveShopping=' + event.id
  }`;

  return <ShareButton shareUrl={shareUrl} />;
};
